import styles from "./ChatDropOverlay.module.css";
import { ACCEPTED_EXTENSIONS_LABEL, MAX_DOCS_PER_SESSION } from "@lib/agent/chatAttachments";
import Icon from "@lib/common/components/Icon/Icon";
import { Box, Stack, Text, ThemeIcon } from "@mantine/core";

export default function ChatDropOverlay({ blockedReason }: { blockedReason?: string }) {
  const isBlocked = blockedReason !== undefined;
  return (
    <Box className={styles.overlay} data-blocked={isBlocked || undefined}>
      <Stack className={styles.panel} align="center" justify="center" gap="xs" px="md">
        <ThemeIcon color="gray" variant="light" radius="md" size="3rem">
          <Icon name={isBlocked ? "ban" : "file-arrow-up"} size="1.5rem" color={isBlocked ? "dimmed" : "blue"} />
        </ThemeIcon>
        <Text fw={600}>{isBlocked ? blockedReason : "Drop files to attach"}</Text>
        {!isBlocked && (
          <Text size="sm" c="dimmed">
            {ACCEPTED_EXTENSIONS_LABEL} · up to {MAX_DOCS_PER_SESSION} documents per session
          </Text>
        )}
      </Stack>
    </Box>
  );
}
